export const TITLE = 'Description';
export const PLACEHOLDER = 'Welcome to this General Biology assessment...';
